const falainaTenantId = '678eb28c-8029-4415-a7dc-a035c0751e3a';

export default falainaTenantId;
